import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class CapitalReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true
		}
	}
	componentDidMount() {
		this.httpPost("api/v1/report/capital")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="container">
			<div className="center-block">
				<div className="row" style={{ "margin-bottom": "20px", "margin-top": "15px" }}>
					<h4 className="txt-gray text-center txt-bold">صورت حساب سرمایه</h4>
					<h5 className="text-muted text-center">{this.state.data.global.company.name}</h5>
					<h5 className="text-muted text-center">تاریخ {this.state.data.today}</h5>
				</div>
				<div className="mr-t-5 text-left">
					<button className="btn btn-no-frame btn-smoke" onClick="journalPrint('capitalstatment')">
						<span className="fa fa-print"></span>
					</button>
					<button className="btn btn-no-frame btn-smoke" onClick="journalPdf('capitalstatment')">
						<span className="fa fa-file-pdf-o"></span>
					</button>
					<button className="btn btn-no-frame btn-smoke" onClick="renderExcel('capitalstatment','','')">
						<span className="fa fa-file-excel-o"></span>
					</button>
				</div>
				<div id="gridContainer" style={{ "height": "auto" }} >
					<table className="table">
						<tbody>
							<tr>
								<td style={{ "text-align": "right" }}>
									<div>شرح</div>
								</td>
								<td style={{ "text-align": "right" }}>
									<div>مبلغ</div>
								</td>
								<td style={{ "text-align": "right" }}>
									<div>تاریخ</div>
								</td>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<td style={{ "text-align": "right" }} > سرمایه اولیه {this.state.data.global.company.name}</td>
								<td style={{ "text-align": "right" }}><span>{this.state.data.sarmaye }</span></td>
								<td style={{ "text-align": "right" }}></td>
							</tr>
							{this.state.data.stockHolders.map(record =>
								<tr>
									<td style={{ "text-align": "right" }}>سهم سود و زیان {record.name}</td>
									<td style={{ "text-align": "right" }}><span>{record.percent}</span></td>
									<td style={{ "text-align": "right" }}>{this.state.data.today}</td>
								</tr>
							)}
							{this.state.data.stockHolders.map(record =>
								<tr>
									<td style={{ "text-align": "right" }} > سرمایه نهایی {record.name}</td>
									<td style={{ "text-align": "right" }}><span>{record.percent}</span></td>
									<td style={{ "text-align": "right" }} > {this.state.data.today}</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}